(ns frontend.view.entity-viewers.modules.counterparty-diligences.event
  (:require
   [re-frame.core :as rf]
   [frontend.controller.websocket.event :as ws]
   [frontend.global-events.toast :as toast]
   [frontend.view.entity-viewers.modules.counterparty-diligences.model :as model]
   [potpuri.core :as p]
   [common.localization :as loc]))

(rf/reg-event-fx
 ::get-counterparty-diligences-associated-with-entity-done
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [success? entity-id]} resp]]
   (if success?
     (let [entities (-> resp
                        :body
                        :entities)
           new-db (-> db
                      (assoc-in (model/entities-full-path entity-id) entities))]
       {:db new-db})
     nil)))

(rf/reg-event-fx
 ::get-counterparty-diligences-associated-with-entity
 [rf/trim-v]
 (fn [_ [entity-id]]
   {::ws/send {:id :counterparty-diligence/get-counterparty-diligences-associated-with-entity
               :body {:entity-id entity-id}
               :on-success [::get-counterparty-diligences-associated-with-entity-done
                            {:success? true
                             :entity-id entity-id}]
               :on-error [::get-counterparty-diligences-associated-with-entity-done
                          {:success? false
                           :entity-id entity-id}]}}))

(rf/reg-event-db
 ::open-create-modal
 [rf/trim-v]
 (fn [db [entity-id]]
   (assoc-in db (model/create-modal-open-full-path entity-id) true)))

(rf/reg-event-db
 ::close-create-modal
 [rf/trim-v]
 (fn [db [entity-id]]
   (p/dissoc-in db (model/create-modal-open-full-path entity-id))))

(rf/reg-event-fx
 ::create-and-send-to-responders-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [entity-id]} _resp]]
   {:db (-> db
            (p/dissoc-in (model/submitting-full-path entity-id))
            (p/dissoc-in (model/create-modal-open-full-path entity-id)))
    :fx [[:dispatch [::get-counterparty-diligences-associated-with-entity entity-id]]]}))

(rf/reg-event-fx
 ::create-and-send-to-responders-error
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [entity-id]} _error]]
   {:db (p/dissoc-in db (model/submitting-full-path entity-id))
    ::toast/error (loc/tr :an-error-occurred)}))

(rf/reg-event-fx
 ::create-project-diligence-and-send-to-responders
 [rf/trim-v]
 (fn [{:keys [db]} [args]]
   (let [{:keys [entity-id project-name fund-name template e-signature-required
                 responders email-subject email-body]} args]
     {:db (assoc-in db (model/submitting-full-path entity-id) true)
      ::ws/send {:id :counterparty-diligence/create-project-diligence-and-send-to-responders
                 :body {:entity-id entity-id
                        :project-name project-name
                        :fund-name fund-name
                        :template template
                        :e-signature-required e-signature-required
                        :responder-ids (mapv :value responders)
                        :email-subject email-subject
                        :email-body email-body}
                 :on-success [::create-and-send-to-responders-success {:entity-id entity-id}]
                 :on-error [::create-and-send-to-responders-error {:entity-id entity-id}]}})))
